import { useEffect } from "react";
import $ from "jquery";
import { createPortal } from "react-dom";
import useTopicFunctions from "../../hooks/useTopicFunctions";

const AcknowledgmentModal = (props) => {
  const { ackModalFade } = useTopicFunctions();
  useEffect(() => {
    $(document).on("click", '[data-target="#acknowledgments"]', function () {
      ackModalFade();
      $(".modal-backdrop").show();
      $(".modal-backdrop").toggleClass("in");
    });

    $("#acknowledgments .close").on("click", function () {
      ackModalFade();
      $(".modal-backdrop").hide();
      $(".modal-backdrop").toggleClass("in");
    });
  }, []);

  return createPortal(
    <>
      <div
        id="acknowledgments"
        className="modal fade"
        tabIndex="-1"
        role="dialog"
        aria-labelledby="myModalLabel"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
              </button>
              <h4 className="modal-title">Acknowledgements</h4>
            </div>
            <div className="modal-body">
              <div
                id="acknowledgmentId"
                className="modal-body"
                style={{ maxHeight: "500px", overflowY: "auto" }}
              ></div>
            </div>
            <div className="modal-footer"></div>
          </div>
        </div>
      </div>
    </>,
    document.getElementById("portal"),
  );
};

export default AcknowledgmentModal;
